module.exports = __webpack_public_path__ + "static/media/frame14.2531df72.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/frame-bottom/frame14.png
// module id = 87
// module chunks = 0